export default __webpack_public_path__ + "static/media/vip-banner-layer.76cec35e.png";